import { Base } from "ui/Scripts/source/framework/base";
import { IPagePanel } from "../common/pagePanel";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { ISavedChartPanel, SavedChartPanel } from "../chart/savedChartPanel";
import { EventPageData, IEventPageData } from "./eventPageData";
import { EventPagePanel } from "./eventPagePanel";

export interface IEventPage extends IEventPageData {
    panels: IPagePanel[];
    chartPanels: ISavedChartPanel[];
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class EventPage extends EventPageData implements IEventPage {
    panels: EventPagePanel[];
    chartPanels: SavedChartPanel[];
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;

    constructor();
    constructor(obj: IEventPage);
    constructor(obj?: any) {
        super(obj);
        this.panels = Base.getTypedArray(obj ? obj.panels : null, EventPagePanel);
        this.chartPanels = Base.getTypedArray(obj ? obj.chartPanels : null, SavedChartPanel);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
